import RoomList from '../components/rooms/RoomList';

function RoomListPage() {
  return <RoomList />;
}

export default RoomListPage;
